<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="./../assets/imgs/91/title-bg.png" alt="" />
      <div class="technological-process">
        
        <div class="zccl">
            <img
                class="top"
                src="./../assets/imgs/90/title-1.png"
                alt=""
            />
            <div class="content">
                <div class="des">
                    （一）实施院士岗位激励资金制度，对每人每月发放8000元岗位激励资金。新增设立在川退休院士慰问金，标准为16000元/人/年。
                  <div class="dutyphone">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-86626452">028-86626452</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            四川省专家服务中心
                        </div>
                  </div>
                </div>
                <div class="des">
                  
                    （二）将在川院士纳入省委掌握联系高层次人才范围。为在川和川籍院士发放“天府英才卡·院士卡”，提供医疗、文化旅游等10方面25项服务，为院士配偶在指定医院就医提供相关便利，院士子女及直系（外）孙子女可享受一次性选择公办学校政策。
                  <div class="dutyphone">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-63092480">028-63092480</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            省委组织部
                        </div>
                  </div>
                </div>
                <div class="des">
                    
                    （三）坚持疗养休假制度，每年有计划地组织专家疗养休假，创新开展集疗养休假、国情省情考察、智力咨询服务等为一体的专家休假活动。
                   <div class="dutyphone">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-63092480">028-63092480</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            省委组织部
                        </div>
                  </div>
                </div>
                <div class="des">
                    （四）全面推行“天府英才卡”制度，为A卡持卡人提供政务、金融、科研、安居、医疗、交通、参观等7个方面19项服务。
                    <div class="dutyphone">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-63092480">028-63092480</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            省委组织部
                        </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import call from "../components/call.vue";
export default {
  data() {
    return {};
  },

  components: {
    call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.xlrclh {
  background-color: $base-back;

  .top-img {
    width: 7.26rem;
    height: 5.6rem;
  }
  .technological-process {
    transform: translateY(-2rem);
    .rhtj {
      position: relative;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #d4e0ff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        font-size: 0.26rem;
        font-weight: 500;
        color: #4e4e4e;
        text-align: left;
        line-height: 0.44rem;
        .font {
          background-color: #fff;
          border-radius: 0.2rem;
          padding: 0.28rem 0.31rem;
        }
      }
    }
    .zccl {
      position: relative;
      margin-top: 0.22rem;
      font-size: 0.26rem;
      .top {
          width: 7.03rem;
          height: 1.37rem;
          margin-left: -0.18rem;
      }
      
      .content {
          width: 6.85rem;
          background: #D4E0FF;
          margin: -0.45rem auto 0;
          padding: 0.33rem;
          box-sizing: border-box;
          border-radius: 0rem 0rem 0.26rem 0.26rem;
          padding-top: 0.28rem;
          
          font-weight: 500;
          text-align: left;
          color: #4e4e4e;
          
          .des {
              color: #4e4e4e;
              text-align: left;
              background: #ffffff;
              border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
              padding: 0.35rem 0.23rem 0.3rem;
              margin-top: 0.2rem;
              position: relative;
              text-align: left;
              line-height: 0.44rem;
              color: #333333;
              font-size: 0.26rem;
              .title {
                  position: absolute;
                  top: -0.6rem;
                  left: 50%;
                  transform: translateX(-50%);
                  width: 100%;
                  // height: 0.67rem;
                  font-size: 0.34rem;
                  
                  // border: 1px solid red;
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  .circle{
                    width: 0.22rem;
                    height: 0.22rem;
                    border: 0.06rem solid #FF6D60;
                    border-radius: 50%;
                  }
              }
              
          }
      }
    }
   
    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }
        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;
            .line {
              position: absolute;
              width: 0.02rem;
              height: 100%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }
            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }
            .line-top {
              display: flex;
              width: 3.31rem;
              height: 0.49rem;
              background-image: url(../assets/imgs/25/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.08rem;
              .line-num {
                width: 0.39rem;
                height: 0.39rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.14rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }
            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .code {
        width: 1.94rem;
        height: 1.94rem;
      }
      .text {
        height: 0.61rem;
      }
    }
  }
}
</style>
